import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20shopping%20scene%20with%20fashion%20items%20elegantly%20arranged%20on%20light%20grey%20stone%20surface%2C%20natural%20daylight%2C%20diverse%20products%20including%20leather%20goods%20accessories%20and%20clothing%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%20no%20watermarks%2C%20gentle%20shadows%2C%20panoramic%20composition&width=1800&height=800&seq=cta-bg-v2&orientation=landscape&nocache=true"
          alt="Itaobuy Spreadsheet shop"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="lg:max-w-lg">
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-white leading-tight mb-4">
              acquista subito
            </h2>
            <p className="text-white/80 text-sm md:text-base leading-relaxed max-w-md">
              Visita il negozio ufficiale Itaobuy Sheet per scoprire tutti i prodotti
              disponibili. Qualità garantita e spedizione veloce.
            </p>
          </div>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group"
          >
            Buy It Now
            <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
              <i className="ri-arrow-right-line text-white text-xs w-4 h-4 flex items-center justify-center"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}